var address = {};
module['exports'] = address;
address.country_code = require("./country_code");
address.city = require("./city");
address.city_name = require("./city_name");
address.default_country = require("./default_country");
address.postcode = require("./postcode");
address.state = require("./state");